var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCopied(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.67842 11.375C4.31166 11.375 3.19922 10.2626 3.19922 8.8958V2.9167H2.17842C1.29349 2.9167 0.574219 3.63586 0.574219 4.5208V12.3958C0.574219 13.2807 1.29349 14 2.17842 14H9.47002C10.3549 14 11.0742 13.2807 11.0742 12.3958V11.375H5.67842Z",
    fill: "#98B1F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 2.45142C13.3333 1.6497 12.6152 1 11.7292 1H5.6042C4.71809 1 4 1.6497 4 2.45142V9.04858C4 9.8503 4.71809 10.5 5.6042 10.5H11.7292C12.6152 10.5 13.3333 9.8503 13.3333 9.04858V2.45142Z",
    fill: "#98B1F0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopied);
export default __webpack_public_path__ + "static/media/icon-copied.b2f0032d.svg";
export { ForwardRef as ReactComponent };